<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(0,0,0,0.4)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true">
</ngx-spinner>